import { color } from '@telus-uds/palette-allium'
import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${color.greyAthens};
  padding: 1.5rem;
`
